import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getMyInfo = () => API.get('/users/me/');

const patchUserInfo = ({ ...info }) => API.patch('/users/me/', { ...info });

const unregisterUser = () => API.delete('/users/me/');

const postReasons = (type, reasons, rating = null) =>
  API.post('/universal-reasons/', { type, reasons, rating });

const getFollowingUserStories = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/me/following-stories/?${params}`);
};

const getFollowingFeeds = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/me/following-feeds/?${params}`);
};

const getReadStories = (page = 1, perPage = 20, sort) => {
  const params = toParams({ page, perPage, sort });
  return API.get(`/users/me/read-stories/?${params}`);
};

const deleteReadStory = (id) => API.delete(`/users/me/read-stories/${id}/`);

const deleteReadStories = (storyIds) =>
  API.delete('/users/me/read-stories/bulk/', { storyIds });

const getCoinHistories = (page = 1) =>
  API.get(`/users/me/coin-histories/?page=${page}`);

const getBalloonHistories = (page = 1) =>
  API.get(`/users/me/balloon-histories/?page=${page}`);

const checkPromotions = () => API.post('/users/me/promotion/');

const getNotifications = (lastEvaluatedKey = null) => {
  const params = toParams({ lastEvaluatedKey });
  return API.get(`/v3/users/me/notifications/?${params}`);
};

const getBlockedUsers = (page = 1) =>
  API.get(`/users/me/block-users/?page=${page}`);

// other users
const getUser = (id) => API.get(`/users/${id}/`);

const followUser = (id) => API.post(`/users/${id}/follow/`);

const getUserFollowers = (id, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/${id}/followers/?${params}`);
};

const getUserFollowings = (id, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/${id}/followings/?${params}`);
};

const toggleBlockUser = (id) => API.post(`/users/${id}/block/`);

// watch later
const getWatchLaterStories = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/me/watch-later-stories/?${params}`);
};

const saveWatchLaterStory = (storyId) =>
  API.post('/users/me/watch-later-stories/', { storyId });

const deleteWatchLaterStory = (storyId) =>
  API.delete(`/users/me/watch-later-stories/${storyId}/`);

const getFirebaseToken = () => API.get('/users/me/firebase/');

const getBadges = (page = 1) => API.get(`/users/me/badges/?page=${page}`);

const getBadge = (id) => API.get(`/users/me/badges/${id}/`);

const patchBadge = (id) => API.patch(`/users/me/badges/${id}/`);

const obtainBadge = (id) => API.post(`/users/me/badges/${id}/obtain/`);

const getUsersMarketItems = (ids) =>
  API.get(`/users/market-item-inventories/?ids=${ids.join(',')}`);

const getUserFans = (id, userIds) =>
  API.get(`/users/${id}/fan-club/users-check/?user_ids=${userIds.join(',')}`);

const getUserSetting = (objectType, objectId) =>
  API.get(`/users/me/settings/${objectType}-${objectId}/`);

const postUserSetting = (objectType, objectId, key, value) =>
  API.post('/users/me/settings/', {
    objectId: `${objectType}-${objectId}`,
    key,
    value,
  });

const u2uActivities = (event, targetUserId) =>
  API.post('/users/me/u2u-activities/', {
    event,
    targetUserId,
  });

// restriction
const getMyRestrictions = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/me/restrictions/?${params}`);
};

const getUserRestriction = (id) => API.get(`/users/${id}/restriction/`);

const getMyCertification = (type) => {
  const params = toParams({ type });
  return API.get(`/users/me/certification/?${params}`);
};

const postMyCertification = (transactionId, type = 'PL') =>
  API.post('/users/me/certification/', {
    transactionId,
    type,
  });

// vouchers
const getMyVouchers = (effectType = 'ALL') => {
  const params = toParams({ effectType });
  return API.get(`/users/me/vouchers/?${params}`);
};

const getMyVoucherRecommendation = (usage, externalId) => {
  const params = toParams({ usage, ...(externalId ? { externalId } : {}) });
  return API.get(`/users/me/vouchers/recommendation/?${params}`);
};

const postVoucher = (voucherId) =>
  API.post(`/users/me/vouchers/${voucherId}/consume/`);

// account setting
const getMySocial = () => API.get('/users/me/social/');
const postMySocialConnect = (social, accessToken, idToken) =>
  API.post('/users/me/social-connect/', {
    social,
    accessToken,
    ...(idToken ? { idToken } : {}),
  });
const postMySocialDisconnect = (social) =>
  API.post('/users/me/social-disconnect/', { social });

const patchMyEmail = (email) => API.patch('/users/me/email/', { email });
const postMyEmailVerification = () => API.post('/users/me/email/verification/');

const getRecommendationNickname = () =>
  API.get('/users/recommendation-nickname/');

export default {
  getMyInfo,
  patchUserInfo,
  unregisterUser,
  postReasons,
  getFollowingUserStories,
  getFollowingFeeds,
  getReadStories,
  deleteReadStory,
  deleteReadStories,
  getCoinHistories,
  getBalloonHistories,
  checkPromotions,
  getNotifications,
  getBlockedUsers,
  // other users
  getUser,
  followUser,
  getUserFollowers,
  getUserFollowings,
  toggleBlockUser,
  // watch later
  getWatchLaterStories,
  saveWatchLaterStory,
  deleteWatchLaterStory,
  getFirebaseToken,
  getBadges,
  getBadge,
  patchBadge,
  obtainBadge,
  getUsersMarketItems,
  getUserFans,
  getUserSetting,
  postUserSetting,
  u2uActivities,
  // restriction
  getMyRestrictions,
  getUserRestriction,
  // certificatoin
  getMyCertification,
  postMyCertification,
  // vouchers
  getMyVouchers,
  getMyVoucherRecommendation,
  postVoucher,
  // account
  getMySocial,
  postMySocialConnect,
  postMySocialDisconnect,
  patchMyEmail,
  postMyEmailVerification,
  getRecommendationNickname,
};



// WEBPACK FOOTER //
// ./src/app/apis/user.js